"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCurrencyToMangoPayCurrency = transformCurrencyToMangoPayCurrency;
const transformCurrencyToCurrencyISO_1 = require("../transformCurrencyToCurrencyISO");
function transformCurrencyToMangoPayCurrency(currency) {
    return currency ? (0, transformCurrencyToCurrencyISO_1.transformCurrencyToCurrencyISO)(currency) : "EUR";
}
//# sourceMappingURL=transformCurrencyToMangoPayCurrency.js.map